import { Button, Heading, Icon, IconButton, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Select, Spinner, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { FaArrowLeft, FaArrowRight, FaTrash } from "react-icons/fa";

import { GET } from "../../../utils/ApiRequestProvider";
import RecycleBin from "./Recyclebin";

export default function DeletedDocuments() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast();
    const [invs, setInvs] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(false);
    const [focusedBusinessId, setFocusedBusinessId] = useState<number | string | undefined>(undefined);

    const convertDate = (date: string | null) => (date ? new Date(date).toLocaleString() : '');

    async function FetchList() {
        setLoading(true);
        try {
            const res = await GET(`/api/internal/deleted-summary`);
            setInvs(res.data.documents ?? []);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error', isClosable: false, duration: 1000, position: 'top-right'
            });
        }
        setLoading(false);
    }

    useEffect(() => {
        FetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaTrash}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Deleted Documents</Heading>
                            <Text fontSize={'sm'}>Here you can view all your deleted documents.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                {/* <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Stack spacing={4} direction='row'>
                            <Checkbox size={'sm'} colorScheme='primary.500'>
                                Include Test
                            </Checkbox>
                            <Checkbox size={'sm'} colorScheme='primary.500'>
                                Include Admin
                            </Checkbox>
                            <Checkbox size={'sm'} colorScheme='primary.500'>
                                Include Data Entry
                            </Checkbox>
                        </Stack>
                        <Button
                            size={'sm'}
                            leftIcon={<FaDatabase />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Get All Data
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<RiFilterOffFill />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Clear Filter
                        </Button>
                    </Stack>
                </Stack> */}
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <Stack
                    w={'full'}
                    spacing={2}
                    align={'center'}
                    direction={'row'}
                    justify={'center'}
                >
                    <Select
                        w={'100%'}
                        size={'sm'}
                        placeholder="Industry"
                    >
                        <option value="option1">IT Industry</option>
                        <option value="option2">Fashion Industry</option>
                        <option value="option3">Law Firm</option>
                    </Select>

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'date'}
                        placeholder={'From'}
                    />

                    <Input
                        w={'full'}
                        size={'sm'}
                        type={'date'}
                        placeholder={'TO'}
                    />

                    <Button
                        w={'full'}
                        size={'sm'}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.500' }}
                        _active={{ bg: 'primary.600' }}
                    >
                        Show Summary
                    </Button>

                    <Button
                        w={'full'}
                        size={'sm'}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.500' }}
                        _active={{ bg: 'primary.600' }}
                    >
                        Clear
                    </Button>
                </Stack>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'} zIndex={1}>
                            <Tr>
                                <Th
                                    color={'white'}
                                >
                                    Organization
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Entity Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Last Deleted Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Elapsed Time
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Deleted Documents Count
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Actions
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.length > 0 ? (
                                    invs.map((inv, i) => (
                                        <Tr key={i}>
                                            <Td>{inv.orgName}</Td>
                                            <Td>{inv.entityName}</Td>
                                            <Td>{convertDate(inv.lastDeletedDate)}</Td>
                                            <Td>{inv.elapsedTime}</Td>
                                            <Td>{inv.deletedDocumentsCount}</Td>
                                            <Td>
                                                <Button
                                                    leftIcon={<FaTrash />}
                                                    colorScheme={'primary'}
                                                    onClick={() => { setFocusedBusinessId(inv.entityId ?? inv.orgId); onOpen(); }}
                                                >
                                                    Recycle Bin
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))
                                ) : (
                                    <Tr>
                                        <Td colSpan={6} textAlign={'center'}>
                                            {loading ? <Spinner size={'sm'} color={'primary.400'} /> : 'No Data Available'}
                                        </Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing {invs.length} of {invs.length} results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select defaultValue={10}>
                            <option value={5}>5 Per Page</option>
                            <option value={10}>10 Per Page</option>
                            <option value={25}>25 Per Page</option>
                            <option value={50}>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Next"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>

            <Modal onClose={onClose} size={'7xl'} isOpen={isOpen}>
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent mx={8}>
                    {/* <ModalHeader>Modal Title</ModalHeader> */}
                    <ModalCloseButton />
                    <ModalBody py={16}>
                        <RecycleBin businessId={focusedBusinessId} />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Stack >
    )
}